export default __webpack_public_path__ + "static/media/history3.0d6510a0.png";